import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CreateTaskError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateTaskError;
  createTask(request: Boundaries["createTask"]["request"]): void;
}

function useTaskCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isTaskCreationRequestPending),
    isRequestSuccess: useSelector(selector.isTaskCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isTaskCreationRequestFailure),
    error: useSelector(selector.getCreateTaskError),
    createTask: core.createTask,
  };
}

export { useTaskCreation };
